import { getFullConfig } from '../Config/auth.config';
import { secureStorage_setItem, secureStorage_removeItem, secureStorage_getItem } from '../utility/secureStorage';

// Add session management helper
const setSessionActive = () => {
    const now = new Date().getTime();
    secureStorage_setItem('vlomni_session_active', 'true');
    secureStorage_setItem('vlomni_auth_timestamp', now.toString());

    // Set cookies
    document.cookie = `vlomni-cookie-active=${now};path=/;max-age=86400`; // 24 hours
    document.cookie = `vlomni-cookie-loggedin=true;path=/;max-age=86400`; // 24 hours

    // Verify session was set
    const verification = {
        sessionActive: secureStorage_getItem('vlomni_session_active'),
        authTimestamp: secureStorage_getItem('vlomni_auth_timestamp'),
        hasCookie: document.cookie.includes('vlomni-cookie-active'),
        hasLoginCookie: document.cookie.includes('vlomni-cookie-loggedin')
    };
};

export const exchangeCodeForTokens = async (code) => {
    try {
        // Prepare headers and request body
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "code": code,
            "idtoken": secureStorage_getItem('idtoken')
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        // Make the token exchange request to our API endpoint
        
        const amzUrl = process.env.REACT_APP_AMZ_API_URL; 
        const response = await fetch(amzUrl + "/vlauth/exchangecodefortokens", requestOptions);

        if (!response.ok) {
            throw new Error(`Token exchange failed: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        // Store tokens in localStorage
        if (data.access_token) secureStorage_setItem('accesstoken', data.access_token);
        if (data.refresh_token) secureStorage_setItem('refreshtoken', data.refresh_token);
        if (data.id_token) secureStorage_setItem('idtoken', data.id_token);

        // Set session as active
        setSessionActive();

        return {
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            id_token: data.id_token,
            expires_in: data.expires_in
        };
    } catch (error) {
        throw error;
    }
};